import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import ForgotPassword from './pages/auth/ForgotPassword';
import Home from './pages/Home';
import ServiceAvailability from './pages/ServiceAvailability';
import GroupOrderCreate from './pages/group/GroupOrderCreate';
import GroupOrderShare from './pages/group/GroupOrderShare';
import GroupOrderSummary from './pages/group/GroupOrderSummary';
import GroupOrderParticipation from './pages/group/GroupOrderParticipation';
import FoodBrowsing from './pages/food/FoodBrowsing';
import FoodDetail from './pages/food/FoodDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/order/OrderConfirmation';
import OrderTracking from './pages/order/OrderTracking';
import OrderHistory from './pages/order/OrderHistory';
import MainLayout from './components/layout/MainLayout';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { OrderProvider } from './context/OrderContext';
import { SocialProvider } from './context/SocialContext';
import { AchievementProvider } from './context/AchievementContext';
import MysteryLunch from './pages/social/MysteryLunch';
import FoodieChallenge from './pages/social/FoodieChallenge';
import ThemedLunches from './pages/social/ThemedLunches';
import FoodPassport from './pages/social/FoodPassport';
import PartyPlanner from './pages/social/PartyPlanner';
import Community from './pages/social/Community';
import Profile from './pages/social/Profile';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <CartProvider data-id="element-2">
          <OrderProvider data-id="element-3">
            <SocialProvider data-id="element-4">
              <AchievementProvider data-id="element-5">
                <Routes data-id="element-6">
                  {/* Auth routes */}
                  <Route path="/login" element={<Login data-id="element-8" />} data-id="element-7" />
                  <Route path="/signup" element={<Signup data-id="element-10" />} data-id="element-9" />
                  <Route path="/forgot-password" element={<ForgotPassword data-id="element-12" />} data-id="element-11" />
                  {/* Main app routes with layout */}
                  <Route path="/" element={<MainLayout data-id="element-14" />} data-id="element-13">
                    <Route index element={<Home data-id="element-16" />} data-id="element-15" />
                    <Route path="service-availability" element={<ServiceAvailability data-id="element-18" />} data-id="element-17" />
                    <Route path="group-order" data-id="element-19">
                      <Route path="create" element={<GroupOrderCreate data-id="element-21" />} data-id="element-20" />
                      <Route path="share/:id" element={<GroupOrderShare data-id="element-23" />} data-id="element-22" />
                      <Route path="summary/:id" element={<GroupOrderSummary data-id="element-25" />} data-id="element-24" />
                      <Route path="participate/:id" element={<GroupOrderParticipation data-id="element-27" />} data-id="element-26" />
                    </Route>
                    <Route path="food" data-id="element-28">
                      <Route index element={<FoodBrowsing data-id="element-30" />} data-id="element-29" />
                      <Route path=":id" element={<FoodDetail data-id="element-32" />} data-id="element-31" />
                    </Route>
                    <Route path="cart" element={<Cart data-id="element-34" />} data-id="element-33" />
                    <Route path="checkout" element={<Checkout data-id="element-36" />} data-id="element-35" />
                    <Route path="order" data-id="element-37">
                      <Route path="confirmation/:id" element={<OrderConfirmation data-id="element-39" />} data-id="element-38" />
                      <Route path="tracking/:id" element={<OrderTracking data-id="element-41" />} data-id="element-40" />
                      <Route path="history" element={<OrderHistory data-id="element-43" />} data-id="element-42" />
                    </Route>
                    {/* New social and gamification routes */}
                    <Route path="mystery-lunch" element={<MysteryLunch data-id="element-45" />} data-id="element-44" />
                    <Route path="foodie-challenge" element={<FoodieChallenge data-id="element-47" />} data-id="element-46" />
                    <Route path="themed-lunches" element={<ThemedLunches data-id="element-49" />} data-id="element-48" />
                    <Route path="food-passport" element={<FoodPassport data-id="element-51" />} data-id="element-50" />
                    <Route path="party-planner" element={<PartyPlanner data-id="element-53" />} data-id="element-52" />
                    <Route path="community" element={<Community data-id="element-55" />} data-id="element-54" />
                    <Route path="profile" element={<Profile data-id="element-57" />} data-id="element-56" />
                  </Route>
                  {/* Redirect to login if no route matches */}
                  <Route path="*" element={<Navigate to="/login" data-id="element-59" />} data-id="element-58" />
                </Routes>
              </AchievementProvider>
            </SocialProvider>
          </OrderProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>;
}